import { Box, Skeleton } from '@factorialco/deprecated-design-system'

const MessageHeaderSkeleton = () => (
  <Box width="full" flexDirection="column" paddingX="s24" paddingY="s12" gap="s8">
    <Box flexGrow flexDirection="row" justifyContent="spaceBetween">
      <Skeleton width="s200" height="s16" />
      <Skeleton width="s96" height="s16" />
    </Box>
    <Box flexGrow flexDirection="column" justifyContent="spaceBetween" gap="s8">
      <Skeleton width="s140" height="s16" />
      <Skeleton width="s200" height="s16" />
    </Box>
  </Box>
)

export default MessageHeaderSkeleton
